<template>
    <div id="app">
        <el-container>
            <el-header>
                <el-image src="http://www.woer.com/dist/images/logo.png"/>
            </el-header>
            <el-main>
                <el-card class="box-card">
                    <div class="box_top">
                        <h2>沃尔核材招聘系统</h2>
                    </div>
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
                        <el-form-item label="账号：" prop="username">
                            <el-input
                                    onkeydown="if(event.keyCode==13) {document.getElementById('loginBtn').click();return false;}"
                                    v-model="ruleForm.username"></el-input>
                        </el-form-item>
                        <el-form-item label="密码：" prop="password">
                            <el-input type="password"
                                      onkeydown="if(event.keyCode==13) {document.getElementById('loginBtn').click();return false;}"
                                      v-model="ruleForm.password"/>
                        </el-form-item>
                        <el-form-item label="验证码：" prop="code">
                            <div style="display: flex">
                                <el-input type="text"
                                          onkeydown="if(event.keyCode==13) {document.getElementById('loginBtn').click();return false;}"
                                          v-model="ruleForm.code"></el-input>
                                <div class="login-code">
                                    <img :src="codeUrl"
                                         @click="getCode">
                                </div>
                            </div>
                        </el-form-item>
                    </el-form>
                    <div style="width: 100%;text-align: center">
                        <el-button type="primary" id="loginBtn" @click="login()">登录</el-button>
                        <el-button type="primary" plain id="registerBtn" @click="register()">注册</el-button>
                    </div>
                </el-card>
            </el-main>
            <el-footer>Copyright © 2022 深圳市沃尔核材股份有限公司 粤ICP备10028260号 咨询热线 0755-28299123</el-footer>
        </el-container>
    </div>
</template>

<script>

    import * as u from '@/util/util'
    import * as c from '@/util/config'

    export default {
        name: "login",
        data() {
            return {
                ruleForm: {
                    username: '',
                    password: '',
                    code: '',
                    randomStr: u.uuid(),
                },
                rules: {
                    username: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                    ],
                    code: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                    ],
                },
                //验证码图片url
                codeUrl: "",
                redirect: undefined // 否则全部重定向到登录页
            }

        },
        watch: {
            $route: {
                handler: function(route) {
                    this.redirect = route.query && route.query.redirect;
                },
                immediate: true
            }
        },
        created() {
            this.getCode();
        },
        methods: {
            //获取验证码
            getCode() {
                this.$HttpService.get("/sys-login/getCode", {
                    randomStr: this.ruleForm.randomStr,
                }).then(res => {
                    this.codeUrl = res;
                    this.randomStr = u.uuid();
                })
            },
            //登录
            login() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.$HttpService.reqForm({
                            url: "/login",
                            method: "post",
                            data: this.ruleForm,
                        }).then(res => {
                            //切换路由
                            //设置存储用户基本信息
                            window.sessionStorage.setItem(c.sessionKey.TOKEN, res.token);
                            this.$util.setSession(c.sessionKey.USER_INFO, res.userInfo);
                            this.$util.setSession(c.sessionKey.SYS_MENU_TREE, res.userInfo.sysMenus);
                            this.$util.setSession(c.sessionKey.SYS_PERMISSIONS, res.userInfo.permissions);
                            //跳转路由
                            this.$router.push(this.redirect || '/')
                        }).catch(() => {
                            this.getCode();
                        })
                    }
                });

            },
            register() {
                this.$router.replace('/register')
                //this.$router.push('/register')
            }

        }
    }
</script>

<style scoped>
    #app {
        width: 100%;
        height: 100%;
        background: url('/static/img/loginBg.jpg');
        background-size: 100%;
    }

    .box_top {
        text-align: center;
        padding: 30px;
    }

    .box-card {
        width: 500px;
        height: 450px;
        padding: 20px;
        margin: 0 auto;
        margin-top: 80px;

    }

    .el-footer {
        background-color: #B3C0D1;
        color: #333;
        text-align: center;
        line-height: 60px;
    }

    .el-main {
        background-color: #E9EEF3;
        color: #333;
        text-align: center;
    }

    .el-header {
        background-color: #E9EEF3;
        color: #333;
        line-height: 60px;
    }

    .el-image {
        margin-top: 20px;
        margin-left: 20px;
    }

</style>
                                                                                                                                                                                                                                                                                                                                   